export const REQUEST_DELAY = 1000;
export const OPTIONS = { wait: REQUEST_DELAY };
export const MAX_TAG_TITLE_LENGTH = 50;
export const AUTOCOMPLETE_MAX_VISIBLE_OPTIONS = 3;
export const AUTOCOMPLETE_DROPDOWN_MENU_MARGIN = 30;
export const AUTOCOMPLETE_TAGS_PAGE_SIZE = 50;
